/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs */



/**
* | output |
* | --- |
* | "Group B Start" |
*
* @param {Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_group_b_start_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Début du groupe B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppe B Start")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizio Gruppo B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Старт группы B")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicio del Grupo B")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("B组开始")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループBスタート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह बी प्रारंभ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Início do Grupo B")
	return /** @type {LocalizedString} */ ("Group B Start")
});